// extracted by mini-css-extract-plugin
module.exports = {"modalWidth":"ModalController_modalWidth__2oLGm","handle":"ModalController_handle__rN7R3"};